(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class CustomerReviewsCarousel extends HTMLElement {
    #track = null;
    #cards = [];
    #currentIndex = 0;
    #autoplayTimer = null;

    connectedCallback() {
      this.#track = this.querySelector('[data-track]');
      this.#cards = [...this.#track.children];

      if (this.#cards.length === 0) return;

      const prevBtn = this.querySelector('[data-prev]');
      const nextBtn = this.querySelector('[data-next]');

      prevBtn?.addEventListener('click', () => this.#slide(-1));
      nextBtn?.addEventListener('click', () => this.#slide(1));

      const speed = parseInt(this.dataset.speed, 10) || 5000;
      this.#startAutoplay(speed);

      this.addEventListener('mouseenter', () => this.#stopAutoplay());
      this.addEventListener('mouseleave', () => this.#startAutoplay(speed));
      this.addEventListener('focusin', () => this.#stopAutoplay());
      this.addEventListener('focusout', () => this.#startAutoplay(speed));
    }

    disconnectedCallback() {
      this.#stopAutoplay();
    }

    #getVisibleCount() {
      const width = window.innerWidth;
      if (width < 750) return 1;
      if (width < 990) return 2;
      return 3;
    }

    #slide(direction) {
      const visibleCount = this.#getVisibleCount();
      const maxIndex = Math.max(0, this.#cards.length - visibleCount);

      this.#currentIndex = Math.min(Math.max(0, this.#currentIndex + direction), maxIndex);

      if (this.#cards.length > 0) {
        const card = this.#cards[0];
        const gap = parseFloat(getComputedStyle(this.#track).gap) || 20;
        const cardWidth = card.offsetWidth + gap;
        const offset = this.#currentIndex * cardWidth;
        this.#track.style.transform = `translateX(-${offset}px)`;
      }
    }

    #startAutoplay(speed) {
      this.#stopAutoplay();
      this.#autoplayTimer = setInterval(() => {
        const visibleCount = this.#getVisibleCount();
        const maxIndex = Math.max(0, this.#cards.length - visibleCount);

        if (this.#currentIndex >= maxIndex) {
          this.#currentIndex = 0;
          this.#track.style.transform = 'translateX(0)';
        } else {
          this.#slide(1);
        }
      }, speed);
    }

    #stopAutoplay() {
      if (this.#autoplayTimer) {
        clearInterval(this.#autoplayTimer);
        this.#autoplayTimer = null;
      }
    }
  }

  customElements.define('customer-reviews-carousel', CustomerReviewsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
